/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-10-29 09:16:09
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

export default class PersistenceStates {
	private static _instance: PersistenceStates | null = null;
	private constructor() {}
	public static get instance() {
		if (!PersistenceStates._instance) {
			PersistenceStates._instance = new PersistenceStates();
		}
		return PersistenceStates._instance;
	}

	private _getter: (() => any) | null = null;
	private _setter: ((value: any) => void) | null = null;

	public get states() {
		return this._getter?.();
	}

	public set states(value: any) {
		this._setter?.(value);
	}

	public install(getter: () => any, setter: (value: any) => void) {
		this._getter = getter;
		this._setter = setter;
	}
}
